import { withInstall } from '../utils'
import _Loading from './Loading'
import './index.scss'

export const Loading = withInstall(_Loading)
export default Loading
